import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import React, { useContext, useState } from "react";
import { FORM_ERROR } from "final-form";
import { toast } from "react-toastify";

// reactstrap components
import { Alert, Button, FormGroup, Form, Row, Col } from "reactstrap";
import { IOtpFormValues } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../common/TextInput";
import { combineValidators, isRequired } from "revalidate";
import LogoCompany from "../common/LogoCompany";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export const LoginAlternativeForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { switchLogin, showRegisterForm } = rootStore.authStore;
  const { company, correctPassword } = rootStore.commonStore;
  const { OtpRequest, loginOtp } = rootStore.userStore;
  const [optSent, setOptSent] = useState(false);
  const [t] = useTranslation(["translation", "guest"], translationHookOptions);

  const changeLoginMethod = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    switchLogin();
  };

  const linkToRegister = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    showRegisterForm();
  };

  const validateRequest = combineValidators({
    email: isRequired("email"),
  });

  const validateLogin = combineValidators({
    email: isRequired("email"),
    otp: isRequired("otp"),
  });

  const handleMicrophoneEditRequest = (e : any) => {
    e.preventDefault();
    
    const userPassword = window.prompt(t("insert_password"));
    if (userPassword === correctPassword) {
      window.location.href = `${window.location.origin}/player//microphone`;
    } else {
      alert(t("incorrect_password"));
    }
  };

  return (
    <div className="form-wrapper  mt-0">
      <div>
        <LogoCompany className="loginLogo" />
      </div>
      <h6>{t("otp_insert_email")}</h6>
      <FinalForm
        initialValues={{
          email: "",
          otp: "",
          companyId: company ? company.id : 1,
        }}
        onSubmit={(values: IOtpFormValues) =>
          optSent
            ? loginOtp(values)
                .then()
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }))
            : OtpRequest(values)
                .then(() => {
                  setOptSent(true);
                  toast.success(t("otp_sent"));
                })
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }))
        }
        validate={optSent ? validateLogin : validateRequest}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <FormGroup className="form-group input-group-lg">
              <Field
                className="form-control"
                name="email"
                component={TextInput}
                placeholder={t("email_placeholder")}
                readOnly={optSent}
              />
            </FormGroup>
            {optSent && (
              <FormGroup className="form-group input-group-lg">
                <Field
                  name="otp"
                  component={TextInput}
                  placeholder={t("otp_placeholder")}
                  autoComplete="off"
                  type="number"
                  className="form-control"
                />
              </FormGroup>
            )}
            {submitError && !dirtySinceLastSubmit && (
              <>
              {submitError.status === 400 ? (
                <Alert color="danger">{t("invalid_claims")}</Alert>
              ) : (
              <Alert color="danger">
                {optSent ? t("invalid_credentials_otp") : t("invalid_email")}
              </Alert>
              )}
              </>
            )}
            <div className="text-center">
              <Button
                disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                className="btn loginButton btn-block btn-lg"
                color="dark"
                type="submit"
              >
                {optSent ? t("login") : t("otp_send")}
              </Button>
            </div>
          </Form>
        )}
      />
      {company &&
        (company.alternativeLoginMethod === "owasp" ||
          company.defaultLoginMethod === "owasp") && (
          <>
            <div className="text-center text-muted mt-4 mb-2">
              <h6 className="linedText">
                <span className="linedSpan">{t("login_method_separator")}</span>
              </h6>
            </div>
            <div className="text-center text-muted mb-1">
              <a
                className="text-muted text-underline"
                href="/#"
                onClick={(e) => changeLoginMethod(e)}
              >
                <u>{t("default_alternative_login")}</u>
              </a>
            </div>
          </>
        )}

      {company && company.allowRegistration && (
        <Row className="mt-3">
          {/* <Col>
            <p className="text-muted">{t("registration_text")}</p>

            <a
              className="btn btn-outline-light btn-sm"
              href="/#"
              onClick={(e) => linkToRegister(e)}
            >
              {t("registration_link")}
            </a>
          </Col> */}
            <Col>
          <a
            className="text-muted text-underline"
            href="/#"
            onClick={(e) => linkToRegister(e)}
          >
           {t("registration_text")}  {t("registration_link")}
          </a>
          </Col>
        </Row>
      )}

      {company && company.allowGuest && (
        <Row style={{marginTop:"2%"}}>
          <Col>
            <a className="text-muted text-underline" href="/guest">
              <u>{t("guest_login_link", { ns: "guest" })}</u>
            </a>
          </Col>
        </Row>
      )}
      {company && company.allowBroadcast && (
        <Col className="text-center" xs="12" style={{marginTop: "10px"}}>
          <a className="text-center text-underline text-muted" href={`${window.location.pathname}//microphone`} onClick={handleMicrophoneEditRequest}>
            <u>{t("microphone_link")}</u>
          </a>
        </Col>
      )}
    </div>
  );
};

export default observer(LoginAlternativeForm);
